<template>
    <div class="room-container">
        <div class="header-row">
            <h1 class="header">{{ room_key }}</h1>
            <form @submit.prevent="">
                <div>
                    <label for="password">Password: </label>
                    <input type="password" v-model.lazy="password" id="password" required>
                </div>
            </form>
            <router-link to="/">
                <img class="back-link-image" src="../assets/back-button.svg" alt="Back to main page" />
            </router-link> 
        </div>
        <a-message-container
            class="messages"
            :messages="messages"
            :password="password"
        />
        <section>
            <a-messager
                :room-key="room_key"
                :password="password"
                @message-posted="retrieveMessages"
            />
        </section>
    </div>
</template>

<script>
import { onMounted, ref } from 'vue';

import AMessager from './a-messager.vue';
import AMessageContainer from './a-message-container.vue';

import * as api from '../api.js';

export default {
    props: {
        room_key: {
            type: String,
            required: true,
        },
    },
    components: {
        AMessager,
        AMessageContainer,
    },
    setup(props) {
        const messages = ref([]);
        const password = ref("");

        const retrieveMessages = () => api.retrieveMessages(props.room_key)
                .then(serverMessages => messages.value = serverMessages);

        onMounted(retrieveMessages);

        return {
            password,
            messages,
            retrieveMessages,
        };
    },
};
</script>

<style scoped>
.room-container {
    display: flex;
    flex-direction: column;
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: hidden;

}

.header-row {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 0.5em;
}

.back-link-image {
    width: 2.2em;
    height: 2.2em;
}

.header {
    font-size: 2em;
    font-weight: bold;
    margin-block-start: unset;
    margin-block-end: unset;
}

.messages {
    border-top: thin solid #333;
    border-bottom: thin solid #333;
    overflow-y: auto;
    overflow-x: hidden;
    flex-grow: 1;
}
</style>